"use client";
import { useEffect, useState, useRef } from "react";
import { BiLogoInstagram } from "react-icons/bi";
import { FaMapMarkedAlt } from "react-icons/fa";
import Link from "next/link";
import Image from "next/image";
import parse from "html-react-parser";

export default function InfoPart({ id }) {
  const [elem, setElem] = useState(null);
  const contentRefs = useRef({});

  useEffect(() => {
    fetch(`${process.env.NEXT_PUBLIC_POST_URL}/api/info/${id}`)
      .then((response) => response.json())
      .then((res) => {
        setElem(res.info);
      })
      .catch(console.error);
  }, [id]);

  const toggleAccordion = (accordionId) => {
    const el = contentRefs.current[accordionId];
    if (el) {
      el.style.maxHeight =
        el.style.maxHeight === "0px" ? `${el.scrollHeight}px` : "0px";
    }
  };

  if (!elem) return <p>Loading...</p>;

  return (
    <>
      {/* Accordion */}
      <div className="accordion_wrapper rounded-md mb-3">
        {elem.accordions?.map((item, index) => {
          const isLast = index === elem.accordions.length - 1;
          return (
            <div
              key={item.accordion_id ?? index}
              className={`accordion_item cursor-pointer ${
                !isLast ? "mb-1" : ""
              }`}
            >
              <div
                className="accordion_title flex py-3 items-center bg-[#bfbfbf] text-white px-4"
                onClick={() => toggleAccordion(item.accordion_id)}
              >
                <Image
                  src="/boton-mas.webp"
                  alt="toggle"
                  width={106}
                  height={40}
                  className="mr-4"
                />
                <h3 className="text-xl font-bold">{item.acc_title}</h3>
              </div>
              <div
                ref={(el) => (contentRefs.current[item.accordion_id] = el)}
                className="accordion_content overflow-hidden transition-[max-height] duration-500 ease-in-out bg-[#ededed] text-gray-600"
                style={{ maxHeight: "0px" }}
              >
                <div className="p-4">
                  <div className="whitespace-pre-line text-gray-700">
                    {parse(item.acc_body ?? "")}
                  </div>
                  <ul className="flex gap-5 mt-6 text-xl">
                    {item.acc_ins && (
                      <li
                        key={`${item.accordion_id}-ins`}
                        className="bg-black p-2 rounded-full text-white"
                      >
                        <Link
                          href={item.acc_ins}
                          target="_blank"
                          className="text-white"
                        >
                          <BiLogoInstagram className="text-white" />
                        </Link>
                      </li>
                    )}
                    {item.acc_map && (
                      <li
                        key={`${item.accordion_id}-map`}
                        className="bg-black p-2 rounded-full text-white"
                      >
                        <Link
                          href={item.acc_map}
                          target="_blank"
                        >
                          <FaMapMarkedAlt className="text-white" />
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* List */}
      <div className="list_wrapper flex items-center gap-3 mb-12">
        {(() => {
          const phoneRegex = /(\+?\d[\d\s-]{7,}\d)/g;
          let firstNumber = null;

          for (let item of elem.lists ?? []) {
            const match = item.list_text.match(phoneRegex);
            if (match) {
              firstNumber = match[0].replace(/\D/g, "");
              break;
            }
          }

          const imageElement = (
            <Image
              src={`${process.env.NEXT_PUBLIC_POST_URL}/api/uploads/${elem.list_image}`}
              alt="whatsapp logo"
              width={60}
              height={40}
            />
          );

          return (
            <>
              {firstNumber ? (
                <Link
                  href={`https://wa.me/+57${firstNumber}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {imageElement}
                </Link>
              ) : (
                imageElement
              )}

              <ul className="w-6/12 list-disc ms-4">
                {(elem.lists ?? []).map((item, index) => {
                  const parts = item.list_text.split(phoneRegex);
                  return (
                    <li
                      key={`list-${index}`}
                      className="text-sm"
                    >
                      {parts.map((part, i) => {
                        if (phoneRegex.test(part)) {
                          const number = part.replace(/\D/g, "");
                          return (
                            <Link
                              key={`num-${index}-${i}`}
                              href={`https://wa.me/+57${number}`}
                              target="_blank"
                              rel="noreferrer"
                              className="text-gray-900 hover:underline"
                            >
                              {part}
                            </Link>
                          );
                        }
                        return <span key={`text-${index}-${i}`}>{part}</span>;
                      })}
                    </li>
                  );
                })}
              </ul>
            </>
          );
        })()}
      </div>
    </>
  );
}
